export default input =>
    input === undefined ? input : JSON.parse(JSON.stringify(input));
